module.exports = __webpack_public_path__ + "media/images/talent/lp/mv02_sp-07fbadf904451eff455b1093e9af868d.png";